import React from "react";
import { appColors, appSpacing } from "../../utils/appTheme";

/**
 * Contenedor de pantalla al estilo app (usado en mobile).
 * - Fondo `page`, padding lateral 20px.
 * - Padding inferior ≥170px + safe-area para que el menú radial no tape contenido.
 * - Slot `header` opcional (AppHeader / user-header) fijo arriba del scroll de la pantalla.
 *
 * En desktop las pantallas siguen renderizando su layout actual; AppScreen se usa
 * dentro de la rama mobile (o cuando isMobile).
 */
const AppScreen = ({ header, children, noPad = false, maxWidth = 480, style }) => (
  <div
    style={{
      background: appColors.page,
      minHeight: "100%",
      display: "flex",
      justifyContent: "center",
    }}
  >
    <div
      style={{
        width: "100%",
        maxWidth,
        display: "flex",
        flexDirection: "column",
        padding: noPad ? 0 : `16px ${appSpacing.screenPad}px`,
        // La limpieza inferior para el menú radial la aporta el contenedor scroll del shell.
        paddingBottom: "calc(40px + env(safe-area-inset-bottom, 0px))",
        boxSizing: "border-box",
        ...style,
      }}
    >
      {header}
      {children}
    </div>
  </div>
);

export default AppScreen;
